import { GET_GROUP_CYCLE_START } from "../../types";

export const group_cycle = (payload) => ({
    type: GET_GROUP_CYCLE_START,
    payload,
});
